// extracted by mini-css-extract-plugin
export default {"customSelectInput":"SelectInput_customSelectInput__akcOk"};